// extracted by mini-css-extract-plugin
export default {"container":"classes_container__KQZR0","item":"classes_item__XP8gi"};